import { useEffect, useRef } from 'react';
import gsap from 'gsap';

export function InteractionLayer(){
 const dot=useRef<HTMLDivElement>(null);
 const ring=useRef<HTMLDivElement>(null);

 useEffect(()=>{
  const fine=matchMedia('(pointer:fine)').matches;
  const reduced=matchMedia('(prefers-reduced-motion: reduce)').matches;
  if(!fine || reduced)return;

  const d=dot.current;
  const r=ring.current;
  if(!d || !r)return;

  document.documentElement.classList.add('custom-cursor-ready');

  gsap.set([d,r],{xPercent:-50,yPercent:-50,x:innerWidth/2,y:innerHeight/2});
  const dotX=gsap.quickTo(d,'x',{duration:.035,ease:'none'});
  const dotY=gsap.quickTo(d,'y',{duration:.035,ease:'none'});
  const ringX=gsap.quickTo(r,'x',{duration:.23,ease:'power3.out'});
  const ringY=gsap.quickTo(r,'y',{duration:.23,ease:'power3.out'});

  const setVisible=(visible:boolean)=>{
    d.dataset.show=visible?'1':'0';
    r.dataset.show=visible?'1':'0';
  };

  const move=(e:PointerEvent)=>{
    dotX(e.clientX);dotY(e.clientY);
    ringX(e.clientX);ringY(e.clientY);
    setVisible(true);
  };

  const over=(e:PointerEvent)=>{
    const target=(e.target as HTMLElement|null)?.closest(
      'a,button,input,textarea,select,[role="button"],[data-cursor]'
    ) as HTMLElement|null;
    const active=!!target;
    r.dataset.active=active?'1':'0';
    d.dataset.active=active?'1':'0';
    r.dataset.label=target?.dataset.cursor||'';
  };

  const enter=()=>setVisible(true);
  const leave=()=>setVisible(false);

  window.addEventListener('pointermove',move,{passive:true});
  document.documentElement.addEventListener('pointerenter',enter);
  document.documentElement.addEventListener('pointerleave',leave);
  document.addEventListener('pointerover',over);

  const cleanups:Array<()=>void>=[];
  document.querySelectorAll<HTMLElement>('.physics-card,.physics-panel').forEach(el=>{
   const tilt=(e:PointerEvent)=>{
    const b=el.getBoundingClientRect();
    if(!b.width||!b.height)return;
    const x=(e.clientX-b.left)/b.width-.5;
    const y=(e.clientY-b.top)/b.height-.5;
    gsap.to(el,{
      rotationY:x*2.2,rotationX:-y*1.8,
      x:x*2.2,y:y*1.6,
      transformPerspective:1200,
      duration:.48,ease:'power3.out',overwrite:true
    });
   };
   const reset=()=>gsap.to(el,{
     rotationX:0,rotationY:0,x:0,y:0,
     duration:.7,ease:'elastic.out(1,.62)',overwrite:true
   });
   el.addEventListener('pointermove',tilt);
   el.addEventListener('pointerleave',reset);
   cleanups.push(()=>{
     el.removeEventListener('pointermove',tilt);
     el.removeEventListener('pointerleave',reset);
   });
  });

  return()=>{
    document.documentElement.classList.remove('custom-cursor-ready');
    window.removeEventListener('pointermove',move);
    document.documentElement.removeEventListener('pointerenter',enter);
    document.documentElement.removeEventListener('pointerleave',leave);
    document.removeEventListener('pointerover',over);
    cleanups.forEach(fn=>fn());
  };
 },[]);

 return <><div ref={ring} className="xy-cursor-ring"/><div ref={dot} className="xy-cursor-dot"/></>;
}
